/**-------------------------------  Copyright ---------------------------------
This software has been developed by Orange Labs TGI/OLS/SOFT
Copyright (c) Orange Labs 2018

COPYRIGHT    : This file is the property of Orange Labs.
Copyright Orange Labs 2018, All Rights Reserved

This software is the confidential and proprietary information of Orange Labs.

You shall not disclose such Confidential Information and shall use it only
in accordance with the terms of the license agreement you entered into with
Orange Labs.

AUTHORS      : Orange Labs  TGI/OLS/SOFT
EMAIL        : soft.cybersec@orange.com
-----------------------------------------------------------------------------*/


import {Component, Prop, Vue} from 'vue-property-decorator'
import EmailValidator from '@/utils/validators/EmailValidator'

@Component
export default class EditableField extends Vue {

    @Prop()
    public type: string

    @Prop()
    public placeholder: string

    @Prop()
    public value: string

    @Prop()
    public autofocus: boolean

    public inEdition: boolean = false

    private hasValidValue: boolean = false

    protected mounted() {
        if (this.value === '') {
            this.inEdition = true
            if (this.autofocus) {
                this.takeTheFocus()
            }
        }
    }

    private takeTheFocus() {
        this.$nextTick(() => { // defer processing to let inEdition to be taken in account
            (this.$refs.editor as HTMLElement).focus()
        })
    }

    private cancel(event: Event) {
        const value = (event.target as HTMLInputElement).value
        if (value && value.trim().length > 0) {
            this.inEdition = false
        }
    }

    private edit() {
        this.inEdition = true
        this.hasValidValue = true
        this.takeTheFocus()
    }

    private save(event: Event) {
        const value = (event.target as HTMLInputElement).value
        this.validate(value)
        if (this.hasValidValue) {
            this.inEdition = false
            this.$emit('input', value)
            this.$emit('validated')
        }
    }

    private validate(value: string) {
        if (this.type === 'email' && value) {
            this.hasValidValue = EmailValidator.isValid(value)
        } else {
            this.hasValidValue = value && value.trim().length > 0
        }
    }
}
